import * as React from "react";
import { Badge, BadgePropsT } from "./Badge";

export type MaxhireBadgePropsT = Omit<BadgePropsT, "text" | "bgColor">;

export const MaxHireBadge = (props: MaxhireBadgePropsT): React.ReactElement => (
  <Badge bgColor="bg-grey-600" text="MAXHIRE" data-testid="maxhire-badge" {...props} />
);
